<template>
  <ul class="product-list">
    <li v-for="(product, index) in products" :key="index">
      <a
        :href="`https://royalhoney.company/products/${product.id}/`"
        target="_blank"
        rel="noopener noreferrer"
      >
        <section class="product">
          <h1>{{ product.name }}</h1>
          <p class="caption">{{ product.caption }}</p>
          <div class="photo">
            <img :src="product.imgUrl" :alt="product.name" />
            <div class="triangle"></div>
          </div>
          <p class="price">
            <span class="num">¥{{ product.price.toLocaleString() }}</span>
            <span class="tax">
              (税込)
            </span>
          </p>
          <p class="pricing">
            <span v-if="product.pricePerBox"
              >1箱あたり ¥{{ product.pricePerBox.toLocaleString() }}</span
            >
            <span v-else></span>
            <span v-if="product.discount" class="discount"
              >¥{{ product.discount.toLocaleString() }} OFF</span
            >
          </p>
        </section>
      </a>
    </li>
  </ul>
</template>

<script>
import { products } from '@/products-data.js'

export default {
  data() {
    return {
      products
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0 8px 56px;

  > li {
    margin: 8px;

    > a {
      color: black;
    }
  }
}

.product {
  width: 100%;
  margin: 32px 8px 0;

  > h1 {
    font-size: 0.875em;
    color: #1c1c3e;
  }

  > .photo {
    position: relative;
    height: 120px;
    margin-top: 12px;

    > img {
      width: calc(100% - 16px);
      height: 100%;
      position: absolute;
      z-index: 2;
    }

    > .triangle {
      background: linear-gradient(
        to left top,
        #efefef 0,
        #efefef 50%,
        transparent 0
      );
      position: absolute;
      width: calc(100% - 16px);
      height: 50%;
      bottom: 0;
      left: 0;
    }
  }

  > .caption {
    font-size: 0.65em;
  }

  > .price {
    margin: 12px 0;

    > .num {
      color: #ccb35f;
      font-weight: bold;
      font-size: 0.875em;
    }
    > .tax {
      font-size: 0.65em;
    }
  }

  > .pricing {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.5em;
    max-width: 100%;

    > .discount {
      color: white;
      background: #c70f42;
      padding: 1px 4px;
      white-space: nowrap;
    }
  }
}
</style>
